import React from 'react'
import {Usestatecontext} from '../../context/AdminDashboard/SystemContext'
import {Usestatemodal} from '../../context/AdminDashboard/SystemModalContext'
import ButtonT from "../../components/atoms/ButtonT";
import Title from "../../components/atoms/Title";
import InputGroup from "../../components/atoms/InputGroup";
import Loading from "../../components/atoms/Loading";
import Navbar from "../../components/main/Navbar";
import EditmodalSub from './EditmodalSub';
import {useConfigContext} from "../../pages/configs/ConfigContext";
import EditSubscriptionModal from "./EditSubscriptionModal";

const SubscriptionSection = () => {
    const {subscriptionCosts,openModal} = useConfigContext()


    return (
        <>
            <Navbar titles={["پیکربندی سیستم"]}/>

            <div
                className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px "
                dir="rtl">
                <div className="flex flex-row justify-between items-center h-10  ">
                    <div className="flex flex-row ">
                        <Title text="تعرفه‌های اشتراک"/>
                    </div>

                    <ButtonT
                        text="ویرایش تعرفه‌ها"
                        onClick={() => {
                            openModal("subscription")
                        }}
                        borderBlue="border-blue border-1"
                    />
                </div>
                <div className="flex flex-row justify-between w-full gap-5 mt-25">
                    <InputGroup
                        label={"هزینه پایه در ازای هرماه"}
                        icon={false}
                        value={subscriptionCosts.month}
                        readOnly={true}
                    />
                    <InputGroup
                        label={"هزینه هر صفحه پیامک"}
                        icon={false}
                        value={subscriptionCosts.sms}
                        readOnly={true}
                    />
                    <InputGroup
                        label={"هزینه هر نفر مهمان"}
                        icon={false}
                        value={subscriptionCosts.guest}
                        readOnly={true}
                    />
                </div>
                <EditSubscriptionModal/>
            </div>

        </>
    )
}

export default SubscriptionSection
